import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import VesselTypeFFFAOService from "@services/VesselTypeFFFAOService";

const ShowVesselTypeFFFAO = ({ vesselTypeFFFAO }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [vesselTypeFFFAOData, setVesselTypeFFFAOData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      VesselTypeFFFAOService.find(vesselTypeFFFAO.id).then((response) => {
        setVesselTypeFFFAOData(response.data.data);
      });
  }, [vesselTypeFFFAO.id, showModal]);

  return (
    <PermissionHandler permission={"view_vessel_types_fffao"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={vesselTypeFFFAOData.name} />
          <RowDetails
            label={t("nameEng")}
            value={vesselTypeFFFAOData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={vesselTypeFFFAOData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowVesselTypeFFFAO;
